module.exports = __webpack_public_path__ + "img/arrow-right.f999fde7.svg";